export function buildKeywordContent(keywords: Array<string | null | undefined>, maxLength: number = 220) {
  const cleaned = keywords
    .map((k) => (k ?? '').trim())
    .filter((k) => k.length > 0);

  const unique: string[] = [];
  for (const k of cleaned) {
    const lowered = k.toLowerCase();
    if (!unique.some((u) => u.toLowerCase() === lowered)) unique.push(k);
  }

  let out = '';
  for (const k of unique) {
    const next = out.length === 0 ? k : `${out}, ${k}`;
    if (next.length > maxLength) break;
    out = next;
  }
  return out;
}

